import React from 'react';
import { Select, Checkbox, Menu, Dropdown, Tooltip } from 'antd';

import { getTaxPayer, checkIfVolumeIsBeingCalculated } from "../../../helpers";

const { Option } = Select
const { Group } = Checkbox;



export default function CheckBoxSelect(props) {
    const { items, handleChage, loading, taxpayerVolume } = props;
    const [checkedList, setCheckedList] = React.useState([]);
    const [checkAll, setCheckAll] = React.useState(false);

    const onclickHandler = e => {
        e.stopPropagation();
    }
    const enableButton = (taxpayer) => {
        if (!taxpayer) return true;
        return !checkIfVolumeIsBeingCalculated(taxpayer.createdDate, taxpayer.updatedDate);
    }
    const formatItems = (items, taxpayerVolume) => {
        return items.map(item => {
            const taxpayer = getTaxPayer(taxpayerVolume, item)
            const enable = enableButton(taxpayer);
            return {
                label: item, value: item, disabled: enable
            }
        })
    }



    const onChange = list => {

        const enableItems = formatItems(items, taxpayerVolume).filter(f => !f.disabled).map(i => i.value);
        setCheckedList(list);
        setCheckAll(list.length === enableItems.length);
        handleChage(list);

    };

    const onCheckAllChange = e => {
        const enableItems = formatItems(items, taxpayerVolume).filter(f => !f.disabled).map(i => i.value);

        setCheckedList(e.target.checked ? enableItems : []);
        handleChage(e.target.checked ? enableItems : []);
        setCheckAll(e.target.checked);
    };


    const menu = (
        <Menu>
            <Menu.Item>
                <Checkbox onClick={onclickHandler} onChange={onCheckAllChange} checked={checkAll}>Seleccionar Todos</Checkbox>
            </Menu.Item>
            <Menu.Item>
                <Group onClick={onclickHandler} options={formatItems(items, taxpayerVolume)} value={checkedList} onChange={onChange} />
            </Menu.Item>
        </Menu>
    );

    return (
        <>
        <div style={
            {
                'display':'flex',
                'flexDirection':'column',
                'alignItems':'center',
                'justifyContent':'center',
                'width':'100%',
                'height':'32px',
            }
        }>
            <Dropdown overlay={menu} trigger={['click']}>
                <Tooltip
                    placement="top"
                    title={"RFC sin calculo estimado mensual no pueden ser seleccionados. Calcular estimado mensual para activarlos."}>
                    <a style={
                        {
                            border:'1px solid rgb(217, 217, 217)',
                            'borderRadius':4,
                            'padding':'4px 18px',
                            'margin':'0 auto',
                            'color':'rgba(0, 0, 0, 0.65)',
                            'height':'32px'
                        }
                    }  onClick={e => e.preventDefault()}>

                        Selecciona RFCs
                    </a>
                </Tooltip>

            </Dropdown>
            </div>
        </>



    );
}
